// TextInput primitive — port of design/v3/SettingsPage.jsx:196-205 inline input pattern.
// 토큰 단일 소스: apps/web-app/src/design/tokens.css. 하드코딩 값 없음.

import type { CSSProperties, InputHTMLAttributes } from 'react';

export type TextInputType = 'text' | 'password' | 'number' | 'email' | 'tel' | 'search' | 'date';

export interface TextInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: TextInputType;
  disabled?: boolean;
  error?: boolean;
  autoComplete?: string;
  style?: CSSProperties;
}

export function TextInput({
  value,
  onChange,
  placeholder,
  type = 'text',
  disabled,
  error,
  autoComplete,
  style,
  ...rest
}: TextInputProps) {
  const borderColor = error ? 'var(--danger)' : 'var(--border-base)';
  return (
    <input
      {...rest}
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      autoComplete={autoComplete}
      style={{
        width: '100%',
        minWidth: 0,
        minHeight: 'var(--control-min-h)',
        boxSizing: 'border-box',
        padding: 'var(--control-pad-y) var(--control-pad-x)',
        fontSize: 13,
        fontFamily: 'var(--font-sans)',
        color: 'var(--fg-1)',
        background: disabled ? 'var(--bg-subtle)' : 'var(--bg-surface)',
        border: `1px solid ${borderColor}`,
        borderRadius: 'var(--radius-sm)',
        outline: 'none',
        transition: 'border-color var(--dur-fast) var(--ease-out)',
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? 'not-allowed' : 'text',
        ...style,
      }}
    />
  );
}
